import React from "react";

// Material ui
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";

// Material icons
import RefreshIcon from "@material-ui/icons/Refresh";

// Styles
import { withStyles } from "@material-ui/core/styles";

// Dependencies
import MomentUtils from "@date-io/moment";

// Redux
import { updateFromToDate } from "../../../redux/actions/dashboardActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { pushMessage, removeMessage } from "../../../redux/actions/commonActions";

const styles = theme => ({
  container: {
    display: "flex",
    width: "calc(80% + 32px)"
  },
  items: {
    display: "flex",
    margin: "auto",
    justifyContent: "space-around"
  },
  formControl: {
    margin: theme.spacing(3)
  }
});

class FromToDate extends React.Component {
  state = {
    fromDate: undefined,
    toDate: undefined,
    fromDateISO: undefined,
    toDateISO: undefined,
    intervalId: undefined,
    checkedAutoReload: false
  };

  handleChangeFrom = e => {
    this.setState({ fromDate: e.format("MM/DD/YYYY hh:mm A"), fromDateISO: e.toISOString(false) });
    this.props.updateFromToDate({
      fromDate: e.format("MM/DD/YYYY hh:mm A"),
      fromDateISO: e.toISOString(false)
    });
  };

  handleChangeTo = e => {
    console.log(e);
    this.setState({ toDate: e.format("MM/DD/YYYY hh:mm A"), toDateISO: e.toISOString(false) });
    this.props.updateFromToDate({
      toDate: e.format("MM/DD/YYYY hh:mm A"),
      toDateISO: e.toISOString(false)
    });
  };

  handleAutoReloadChange = name => event => {
    this.props.updateFromToDate({ [name]: event.target.checked });
  };

  handleReloadButton = () => {
    this.props.updateFromToDate({
      fromDate: this.props.dashboardDates.fromDate,
      toDate: this.props.dashboardDates.toDate,
      refresh: this.props.dashboardDates.refresh + 1
    });
  };

  turnOnOffAutoReload = reloadingState => {
    if (reloadingState && !this.state.intervalId) {
      let intervalId = setInterval(e => {
        this.props.updateFromToDate({
          fromDate: this.props.dashboardDates.fromDate,
          toDate: this.props.dashboardDates.toDate,
          refresh: this.props.dashboardDates.refresh + 1
        });
      }, 10000);
      this.setState({ intervalId: intervalId });
      this.props.pushMessage({
        type: "info",
        message: "Auto refresh is turned on. Dashboard will update each 10 seconds."
      });
    } else {
      if (reloadingState === false && this.state.intervalId) {
        clearInterval(this.state.intervalId);
        this.setState({ intervalId: undefined });
      }
    }
  };

  componentDidMount() {
    if (this.props.dashboardDates.checkedAutoReload) {
      this.turnOnOffAutoReload(this.props.dashboardDates.checkedAutoReload);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      fromDate: this.props.dashboardDates.fromDate,
      toDate: this.props.dashboardDates.toDate,
      fromDateISO: this.props.fromDateISO,
      toDateISO: this.props.toDateISO
    });
    if (nextProps.dashboardDates.checkedAutoReload !== this.props.dashboardDates.checkedAutoReload)
      this.turnOnOffAutoReload(nextProps.dashboardDates.checkedAutoReload);
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    this.setState({ intervalId: undefined });
  }

  render() {
    const { classes, toggleMoveMode, toggleEditMode, editMode, moveMode } = this.props;
    const { fromDate, toDate, checkedAutoReload } = this.props.dashboardDates;
    return (
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12} md={8} lg={5} className={classes.items}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <span style={{ margin: "2px" }}>
              <DateTimePicker
                autoOk
                id="from_date_picker"
                inputVariant="outlined"
                label="From date:"
                ampm={true}
                value={fromDate}
                format="MM/DD/YYYY hh:mm A"
                onChange={this.handleChangeFrom}
                maxDate={this.props.dashboardDates.toDate}
              />
            </span>
            <span style={{ margin: "2px" }}>
              <DateTimePicker
                autoOk
                id="to_date_picker"
                inputVariant="outlined"
                label="To date:"
                ampm={true}
                value={toDate}
                format="MM/DD/YYYY hh:mm A"
                onChange={this.handleChangeTo}
                minDate={this.props.dashboardDates.fromDate}
                showTodayButton
                disableFuture
              />
            </span>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={4} lg={3} className={classes.items}>
          <FormControlLabel
            value="top"
            control={
              <Checkbox
                checked={checkedAutoReload}
                onChange={this.handleAutoReloadChange("checkedAutoReload")}
                value="checkedAutoReload"
                color="primary"
                inputProps={{
                  "aria-label": "secondary checkbox"
                }}
              />
            }
            label="Auto Refresh"
          />
          <Tooltip title="Manual Refresh">
            <IconButton
              color="secondary"
              onClick={this.handleReloadButton}
              disabled={this.props.dashboardDates.checkedAutoReload}
            >
              <RefreshIcon style={{ width: 40, height: 40, color: "#2980b9" }} />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={12} md={12} lg={4} className={classes.items}>
          <FormControl component="fieldset">
            <FormGroup row>
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    checked={editMode}
                    onChange={toggleEditMode}
                    value="checkedAutoReload"
                    color="primary"
                    inputProps={{
                      "aria-label": "secondary checkbox"
                    }}
                  />
                }
                label="Edit Widgets"
              />
              <FormControlLabel
                value="top"
                control={
                  <Checkbox
                    checked={moveMode}
                    onChange={toggleMoveMode}
                    value="checkedAutoReload"
                    color="primary"
                    inputProps={{
                      "aria-label": "secondary checkbox"
                    }}
                  />
                }
                label="Reorder Widgets"
              />
            </FormGroup>
          </FormControl>
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    dashboardDates: state.dashboard.widgetFromToDate,
    message: state.common.message
  };
}
function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        updateFromToDate,
        pushMessage,
        removeMessage
      },
      dispatch
    ),
    dispatch
  };
}

FromToDate = withStyles(styles)(FromToDate);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FromToDate);
